import dayjs from 'dayjs';
import { queryClient } from '@root/src/providers/query';
import { lastOrdersQueryOptions } from '@queries/peopleOrders';
import {
  pushFlocktoryGuestOrdersToDataLayer,
  pushFlocktoryUserOrdersToDataLayer
} from './pushUserOrders';

export const syncFlocktoryUserOrdersDataLayer = async (
  isUserLoggedIn: boolean,
  userEmail?: string | null
): Promise<void> => {
  if (!isUserLoggedIn) {
    pushFlocktoryGuestOrdersToDataLayer();
    return;
  }

  try {
    const data = await queryClient.fetchQuery(lastOrdersQueryOptions());

    const ordersCount = data?.totalCount ?? 0;
    const lastOrderDateRaw = data?.orders?.[0]?.date;
    const lastOrderDate = lastOrderDateRaw
      ? dayjs(lastOrderDateRaw).toISOString()
      : null;

    pushFlocktoryUserOrdersToDataLayer({
      ordersCount,
      lastOrderDate,
      hasEmail: userEmail?.trim() ? 1 : 0
    });
  } catch (error) {
    console.log('Flocktory user orders dataLayer sync error:', error);
  }
};
